import { Accordion, SimpleGrid, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next';

import { NUMBER_OF_QUESTIONS } from 'constants/app';
import { IconCaretDownFilled } from '@tabler/icons-react';
import classes from './index.module.css';
import React from 'react';

const AccordionItem = () => {
    const { t } = useTranslation();

    const questions = Array.from({ length: NUMBER_OF_QUESTIONS }).map((_, index) => {
        const questionKey = `faq.questions.${index}`;
        const answerTable = t(`${questionKey}.answerTable`, { returnObjects: true });
        const isTable = Array.isArray(answerTable) && answerTable.length > 0;

        return (
            <Accordion.Item key={t(`${questionKey}.question`)} value={t(`${questionKey}.question`)} className={classes.question}>
                <Accordion.Control>{t(`${questionKey}.question`)}</Accordion.Control>
                <Accordion.Panel>
                    {isTable ? (
                        <SimpleGrid cols={2} spacing="sm" className={classes.table}>
                            {answerTable.map((item, rowIndex) => {
                                if (item.type === 'header') {
                                    return (
                                        <Text
                                            key={rowIndex}
                                            fw={700}
                                            style={{ gridColumn: 'span 2', marginTop: rowIndex === 0 ? 0 : '1rem' }}
                                        >
                                            {item.values[0]}
                                        </Text>
                                    );
                                } else {
                                    const [col1, col2] = item.values;
                                    return (
                                        <React.Fragment key={rowIndex}>
                                            <Text fw={500}>{col1}</Text>
                                            {Array.isArray(col2) ? (
                                                <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                                    {col2.map((li, i) => (
                                                        <li key={i}><Text>{li}</Text></li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <Text>{col2}</Text>
                                            )}
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </SimpleGrid>
                    ) : (
                        t(`${questionKey}.answer`)
                    )}
                </Accordion.Panel>
            </Accordion.Item>
            )
        });

    return (
        <Accordion variant='separated' chevron={<IconCaretDownFilled className={classes.icon} />} classNames={{ root: classes.root, item: classes.item, label: classes.label, control: classes.control, panel: classes.panel }}>
            <SimpleGrid cols={{ base: 1, md: 2 }} className={classes.questions}>
                {questions}
            </SimpleGrid>
        </Accordion>
    )
}

export default AccordionItem;